export default __webpack_public_path__ + "static/media/diego.326a2d64.jpeg";